import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { EditFormationsDialogComponent } from '../edit-formations-dialog/edit-formations-dialog.component';
import { UserWellsService } from '../user-wells.service';
import { WellDetailsModel } from '../_models/well-details-model';

@Component({
  selector: 'app-well-details-display',
  templateUrl: './well-details-display.component.html',
  styleUrls: ['./well-details-display.component.css']
})
export class WellDetailsDisplayComponent implements OnInit {

  @Input() well: WellDetailsModel;

  constructor(private dialog: MatDialog, private userWellsService: UserWellsService) { }

  ngOnInit(): void {
  }

  editFormations() {
    this.userWellsService.requestEditFormations(this.well);
  }

}
